import ReactSelect, { formatDotLabel, formatDotStyles } from '../ReactSelect';
import React from 'react';
import colors from '../../theme/colors';
import { ActionMeta, OnChangeValue } from 'react-select';

export const flagOptions: FlagOption[] = [
  {
    value: 'clear',
    label: 'No Flags',
    color: colors.statusSuccess,
    filter: {
      initialResult: 'PASS',
      backflowAssemblyEdited: false,
      properlyInstalled: true,
      testable: true,
    },
  },
  {
    value: 'fail',
    label: 'Failed',
    color: colors.statusError,
    filter: {
      finalResult: 'FAIL',
    },
  },
  {
    value: 'failPass',
    label: 'Failed then Passed',
    color: colors.failPass,
    filter: {
      initialResult: 'FAIL',
      finalResult: 'PASS',
    },
  },
  {
    value: 'backflowAssemblyEdited',
    label: 'Edited',
    color: colors.statusYellow,
    filter: {
      backflowAssemblyEdited: true,
    },
  },
  {
    value: 'properlyInstalled',
    label: 'Improper Install',
    color: colors.statusOrange,
    filter: {
      properlyInstalled: false,
    },
  },
  {
    value: 'testable',
    label: 'Unable to Test',
    color: colors.statusError,
    filter: {
      testable: false,
    },
  },
] as const;

type FlagOption = {
  value: string;
  label: string;
  filter: Record<string, any>;
  color: string;
};

export const BackflowTestFlagsPicker = ({
  value,
  onChange,
}: {
  value?: string[];
  onChange?: (
    newValue: OnChangeValue<FlagOption, true>,
    actionMeta: ActionMeta<FlagOption>
  ) => void;
}) => (
  <ReactSelect<FlagOption, true, any>
    placeholder="flags"
    isMulti
    isClearable={false}
    styles={{
      menu: (base) => ({
        ...base,
        minWidth: '200px',
      }),
      multiValue: formatDotStyles,
    }}
    formatOptionLabel={formatDotLabel}
    onChange={onChange}
    value={
      Array.isArray(value)
        ? value.map((flag) =>
            flagOptions.find((flagOption) => flagOption.value === flag)
          )
        : ([] as any[])
    }
    options={flagOptions}
  />
);
